<template>

  <div id="school">
    <form action="/">
        <van-search
            v-model="value"
            show-action
            placeholder="请输入学校名称"
             @search="onSearch"
             @cancel="onCancel"
        />
    </form>

    <van-list>
        <div class="schoolitem" v-for="(school,index) in schools"
        :key="index" @click="select(school)" v-track="{ name: 'selectSchool' }">
            {{school.name}}
        </div>
    </van-list>

  </div>

</template>

<script>

import Search from 'vant/lib/search';
import "vant/lib/search/style";
import List from 'vant/lib/list';
import "vant/lib/list/style";

import { api_bindSchool } from "@/api"

export default {
  name: 'School',
  data(){
      return {
        value:'',
        schools:[],
      }
  },
  components: {
      'van-search':Search,
      'van-list': List,

  },
  methods:{
      select(school){
        console.log(school.name);
        this.$store.commit('cmtBindSchoolinfo',school);
        this.$router.back();
      },
      onSearch(event){
          api_bindSchool(this.$store.state.bindCitycode
          ,event,this.$store.state.token).then(res=>{
            this.schools = res.data;
          }).catch(er=>console.log(er));
      },
      onCancel(event){
          console.log(event);
      }
  },
  mounted(){

  },
  created(){
    this.$track('start_school')

    this.$store.dispatch('share/initShareParams')

    setTimeout(() => {
       api_bindSchool(this.$store.state.bindCitycode
          ,"",this.$store.state.token).then(res=>{
            this.schools = res.data;
          }).catch(er=>console.log(er));
    }, 200);
  }

}
</script>

<style  lang="scss">

        .schoolitem{
            position: relative;
            padding: 10px 16px;
        }

        .schoolitem::after{
            height: 0.55px;
            content: "";
            width: 100%;
            background: #dadada !important;
            position: absolute;
            right: 0;
            -webkit-transform: scaleY(0.35);
            -ms-transform: scaleY(0.35);
            transform: scaleY(0.35);
            z-index: 99;
            bottom:0px;
        }

</style>
